import {Component} from '@angular/core';

@Component({
    templateUrl: './contactus.component.html'
})
export class ContactusComponent {
}
